//===================================================
// 1.Load,Init,Settings
//===================================================
import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Material-ui
import { Container, Paper, Box, Typography, Link } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";

// custom components
import WithCenteredLogoTemplate from "../../templates/WithCenteredLogoTemplate";

// css *required
import { useStyles } from "./index.css";

//===================================================
// 2.Main Component
//===================================================
const EmailVerified = (props) => {
  // 2-1. useStyles *require
  const classes = useStyles();

  // 2-2. Store
  const navigate = useNavigate();
  const backToBookingPage = () => {
    navigate("/");
  };
  const { id } = useParams();
  useEffect(() => {
    const sendEmailVerification = async () => {
      try {
        const response = await axios.patch(`/api/users/verify-email/${id}`);
        console.log(response);
      } catch (error) {
        console.log(error);
        navigate("/");
      }
    };

    sendEmailVerification();
    return () => {
      navigate("/", {});
    };
  }, [id, navigate]);
  // showMain
  return showMain({
    ...props,
    classes,
    backToBookingPage,
  });
};

//===================================================
// 3.Export
//===================================================
export default EmailVerified;

//===================================================
// 4.propTypes and defaultProps
//===================================================

//4-1. propTypes
EmailVerified.propTypes = {};

//4-2. defaultProps
EmailVerified.defaultProps = {};

//===================================================
// 5.Functions *require showMain()
//===================================================
/**
 * Show main
 * @param {*} props
 */
const showMain = (props) => {
  return <WithCenteredLogoTemplate children={EmailVerifiedTemplate(props)} />;
};

const EmailVerifiedTemplate = (props) => {
  const { backToBookingPage } = props;
  return (
    <Container align="center" maxWidth="sm">
      <Box sx={{ mt: 7, mb: 12 }}>
        <Paper
          background="light"
          sx={{ py: { xs: 4, md: 8 }, px: { xs: 3, md: 6 } }}
        >
          <CheckCircleOutline color="success" sx={{ fontSize: 130 }} />
          <Typography variant="body1" gutterBottom component="div">
            Email succesfully verified!
          </Typography>
          <Link component="button" variant="body2" onClick={backToBookingPage}>
            Home
          </Link>
        </Paper>
      </Box>
    </Container>
  );
};

//===================================================
// 6.Actions
//===================================================
